let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("63spp")).then(() => parcelRequire('1hPWF'));